// Mock data for David's Harmony House Foundation

export const heroData = {
  title: "Transforming Lives, Building Futures",
  subtitle: "A Faith-Based Continuum of Care Ecosystem",
  description: "David's Harmony House Foundation partners with communities to provide pathways of restoration and economic empowerment for veterans, elderly, foster youth, and individuals transitioning from incarceration.",
  stats: [
    { number: "500+", label: "Lives Transformed" },
    { number: "4", label: "Core Programs" },
    { number: "15+", label: "Partner Organizations" },
    { number: "95%", label: "Success Rate" }
  ],
  images: [
    "https://images.unsplash.com/photo-1529209076408-5a115ec9f1c6",
    "https://images.unsplash.com/photo-1762160974215-b501fe23b747",
    "https://images.pexels.com/photos/7156196/pexels-photo-7156196.jpeg"
  ]
};

export const aboutData = {
  mission: "To create sustainable pathways of restoration, dignity, and economic empowerment for underserved populations through comprehensive support services and community partnerships.",
  vision: "A community where every person—regardless of their past—has access to the resources, support, and opportunities needed to build a thriving future.",
  story: "David's Harmony House Foundation Inc. operates as part of a larger social enterprise ecosystem, providing integrated support services across four critical areas of community need. In partnership with J K Awesome Deeds LLC (Founder & CEO: Javier Cruz) and key institutional partners including Orange County Government Florida, US Department of Veterans Administration, Securities Exchange Commission, and community faith-based organizations, we deliver comprehensive programs that address housing, healthcare, education, and economic empowerment.",
  founder: {
    name: "Javier Cruz",
    title: "Founder & CEO, J K Awesome Deeds LLC",
    bio: "Leading the charge in creating sustainable social impact infrastructure through innovative partnerships and community-centered solutions.",
    image: "https://customer-assets.emergentagent.com/job_harmony-nonprofit/artifacts/cf8wzfc8_Javier%20Cruz%202026%20Profil%20Picture.jpg"
  }
};

export const programsData = [
  {
    id: "veei",
    name: "Veterans Economic Empowerment Initiative (VEEI)",
    shortName: "VEEI",
    tagline: "Honoring Service Through Economic Opportunity",
    description: "Comprehensive support for veterans transitioning to civilian life, including housing assistance, job training, mental health services, and economic empowerment programs.",
    icon: "Shield",
    image: "https://images.unsplash.com/photo-1761839257870-06874bda71b5",
    features: [
      "Transitional and permanent housing solutions",
      "Job training and placement services",
      "Mental health and PTSD support",
      "Financial literacy and entrepreneurship programs",
      "Peer support networks",
      "VA benefits navigation assistance"
    ],
    stats: {
      served: "150+ Veterans",
      housed: "85% Housing Success",
      employed: "78% Employment Rate"
    },
    partnerOrgs: ["US Department of Veterans Administration", "Orange County Government"]
  },
  {
    id: "assisted-living",
    name: "Assisted Living for the Elderly",
    shortName: "Senior Care",
    tagline: "Dignity and Compassion in Every Season",
    description: "Quality assisted living services that honor the dignity of our elderly community members, providing safe housing, healthcare coordination, and enriching daily activities.",
    icon: "Heart",
    image: "https://images.unsplash.com/photo-1543333995-a78aea2eee50",
    features: [
      "Safe and comfortable housing accommodations",
      "24/7 care and support services",
      "Healthcare coordination and medication management",
      "Nutritious meals and dietary support",
      "Social activities and community engagement",
      "Transportation assistance"
    ],
    stats: {
      served: "75+ Seniors",
      satisfaction: "98% Satisfaction",
      care: "24/7 Support"
    },
    partnerOrgs: ["Community Faith-Based Organizations", "Orange County Health Services"]
  },
  {
    id: "foster-youth",
    name: "Foster Youth Transition Program",
    shortName: "Youth Transition",
    tagline: "Empowering Tomorrow's Leaders Today",
    description: "Supporting foster children as they transition to independent adulthood through life skills training, education support, housing assistance, and mentorship.",
    icon: "Users",
    image: "https://images.unsplash.com/photo-1639432038099-4379f2d421cc",
    features: [
      "Transitional housing for youth aging out of foster care",
      "Life skills training and education support",
      "Career counseling and job placement",
      "Financial literacy and budgeting education",
      "Mentorship and peer support programs",
      "Access to continuing education resources"
    ],
    stats: {
      served: "120+ Youth",
      education: "90% In School/Training",
      housing: "82% Housing Stability"
    },
    partnerOrgs: ["Orange County Department of Children and Families", "Local Educational Institutions"]
  },
  {
    id: "reentry",
    name: "DOJ Corrections Reentry Program",
    shortName: "Reentry Support",
    tagline: "Second Chances, New Beginnings",
    description: "Comprehensive reentry support for men and women transitioning from incarceration to civilian life, breaking cycles of recidivism through housing, employment, and community integration.",
    icon: "Home",
    image: "https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca",
    features: [
      "Transitional housing and case management",
      "Employment readiness and job placement",
      "Substance abuse treatment and mental health support",
      "Legal aid and records assistance",
      "Family reunification services",
      "Community integration and peer support"
    ],
    stats: {
      served: "200+ Individuals",
      employed: "72% Employment Success",
      recidivism: "15% Recidivism Rate"
    },
    partnerOrgs: ["Florida Department of Corrections", "Orange County Reentry Coalition"]
  }
];

export const partnershipsData = [
  {
    name: "Orange County Government Florida",
    type: "Government Partner",
    description: "Collaborative partnership providing funding, resources, and policy support for community programs.",
    logo: null
  },
  {
    name: "US Department of Veterans Administration",
    type: "Federal Partner",
    description: "Supporting veterans through the Homelessness Prevention Program and comprehensive VA benefits.",
    logo: null
  },
  {
    name: "Securities Exchange Commission",
    type: "Regulatory Partner",
    description: "Oversight and compliance support for our social enterprise financial operations.",
    logo: null
  },
  {
    name: "J K Awesome Deeds LLC",
    type: "Strategic Partner",
    description: "Founded by Javier Cruz, providing property leasing and social enterprise infrastructure for all foundation programs.",
    logo: null
  },
  {
    name: "Community Faith-Based Organizations",
    type: "Community Partners",
    description: "Network of local churches and faith communities providing spiritual support, volunteers, and community resources.",
    logo: null
  },
  {
    name: "Florida Department of Corrections",
    type: "Government Partner",
    description: "Collaborative reentry initiatives supporting successful transitions from incarceration to community life.",
    logo: null
  }
];

export const successStoriesData = [
  {
    id: 1,
    name: "James M.",
    program: "Veterans Economic Empowerment Initiative",
    quote: "After serving 12 years in the Army, I found myself homeless and struggling with PTSD. VEEI didn't just give me a roof over my head—they gave me purpose again. Today, I'm employed, stable, and helping other veterans find their way.",
    image: null,
    outcome: "Housed, Employed, Peer Mentor"
  },
  {
    id: 2,
    name: "Maria S.",
    program: "Foster Youth Transition",
    quote: "Aging out of foster care was terrifying. The Youth Transition Program taught me how to budget, cook, and believe in myself. I'm now in college studying social work so I can help others like me.",
    image: null,
    outcome: "College Student, Independent Living"
  },
  {
    id: 3,
    name: "Robert T.",
    program: "Reentry Support",
    quote: "I made mistakes that cost me 8 years of my life. The Reentry Program saw beyond my past and invested in my future. I'm now 3 years sober, employed full-time, and reunited with my daughter.",
    image: null,
    outcome: "3 Years Sober, Employed, Reunified Family"
  },
  {
    id: 4,
    name: "Dorothy L.",
    program: "Assisted Living",
    quote: "At 78, I thought I'd lost my independence. The care and dignity I receive here has given me joy in my golden years. I'm surrounded by friends and feel truly valued.",
    image: null,
    outcome: "Thriving, Engaged, Supported"
  }
];

export const volunteerOpportunities = [
  {
    title: "Program Mentors",
    description: "Provide one-on-one guidance and support to program participants",
    commitment: "4-6 hours/week",
    icon: "UserCircle"
  },
  {
    title: "Skills Training Instructors",
    description: "Teach job skills, financial literacy, or life skills workshops",
    commitment: "Flexible schedule",
    icon: "BookOpen"
  },
  {
    title: "Event Volunteers",
    description: "Help with fundraising events, community outreach, and program activities",
    commitment: "Occasional",
    icon: "Calendar"
  },
  {
    title: "Administrative Support",
    description: "Assist with office tasks, data entry, and program coordination",
    commitment: "2-4 hours/week",
    icon: "Briefcase"
  }
];

export const faqData = [
  {
    question: "How can I apply for program services?",
    answer: "You can apply through our 'Get Help' page by filling out an application form. Our intake coordinators will contact you within 48 hours to discuss your needs and eligibility for our programs."
  },
  {
    question: "Are your services free?",
    answer: "Yes, all of our programs are provided at no cost to qualified participants. Our services are funded through grants, donations, and partnerships with government agencies and community organizations."
  },
  {
    question: "How can I make a donation?",
    answer: "You can donate securely online through our website, by mail, or by contacting our development office. We accept one-time and recurring donations. David's Harmony House Foundation is a registered 501(c)(3) nonprofit, and all donations are tax-deductible."
  },
  {
    question: "What areas do you serve?",
    answer: "We primarily serve Orange County, Florida, and surrounding areas. Some programs may have specific geographic requirements based on funding and partnership agreements."
  },
  {
    question: "How can organizations partner with you?",
    answer: "We welcome partnerships with businesses, government agencies, faith-based organizations, and community groups. Please contact us through our partnerships inquiry form to discuss collaboration opportunities."
  }
];

export const contactInfo = {
  email: "info@DavidsHarmonyHouse.org",
  infoEmail: "info@DavidsHarmonyHouse.org",
  adminEmail: "admin@davidsharmonyhouse.org",
  phone: "Corporate : (407) 637-6917",
  address: "(Orange County) Orlando, Florida 32811",
  hours: "Monday - Friday: 9:00 AM - 5:00 PM"
};
